const SEO = [
	{
		page: "home",
		description:
			"I'm seeking a full-time SDE position. I possess proficiency in a range of technical skills.",
		keywords: ["Mengyun Xie", "Miya", "Software Engineer"],
	},

	{
		page: "about",
		description:
			"I'm seeking a full-time SDE position. I possess proficiency in a range of technical skills.",
		keywords: ["Mengyun Xie", "Miya", "Software Engineer"],
	},

	{
		page: "resume",
		description:
			"I'm seeking a full-time SDE position. I possess proficiency in a range of technical skills.",
		keywords: ["Mengyun Xie", "Miya", "Software Engineer"],
	},

	{
		page: "projects",
		description:
			"I'm seeking a full-time SDE position. I possess proficiency in a range of technical skills.",
		keywords: ["Mengyun Xie", "Miya", "Software Engineer"],
	},

	{
		page: "contact",
		description:
			"I'm seeking a full-time SDE position. I possess proficiency in a range of technical skills.",
		keywords: ["Mengyun Xie", "Miya", "Software Engineer"],
	},
];

export default SEO;
